<mat-card class="legalization-details-card">
  <mat-card-header class="legalization-details-header">
    <div class="header-title">
      <mat-card-title class="details-header">
        <div class="details-header-title">{{ 'Legalization.Details.Title' | translate }}</div>
        @if (
          legalizationDetails?.DocumentDetails?.DocumentAlertStatusId &&
          legalizationDetails?.DocumentDetails?.DocumentAlertStatusId != legalizationAlertStatusEnum.NoAlert
          ) {
          <div
            class="status-label details-header-status"
            [ngClass]="getAlertStatusClass(legalizationDetails?.DocumentDetails?.DocumentAlertStatusId)"
            >
            {{ legalizationDetails?.DocumentDetails?.DocumentAlertStatusName }}
          </div>
        }
        <div class="details-header-empty"></div>
      </mat-card-title>
    </div>
    <table class="detail-table header-detail-table">
      <colgroup>
      <col class="detail-col-label" />
      <col class="detail-col-value" />
    </colgroup>
    <tbody>
      <tr>
        <td>{{ 'Legalization.Details.FullName' | translate }}</td>
        <td>{{ legalizationDetails?.FullName }}</td>
      </tr>
      <tr>
        <td>{{ 'Legalization.Details.IdentityDocumentType' | translate }}</td>
        <td>{{ legalizationDetails?.IdentityDocumentType }}</td>
      </tr>
      <tr>
        <td>{{ 'Legalization.Details.IdentityDocumentNumber' | translate }}</td>
        <td>{{ legalizationDetails?.IdentityDocumentNumber }}</td>
      </tr>
      <tr>
        <td>{{ 'Legalization.Details.LegalizationStatus' | translate }}</td>
        <td>
          <div class="status-label status-width" [ngClass]="getStatusClass(legalizationDetails?.LegalizationStatusId)">
            {{ legalizationDetails?.LegalizationStatusName }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <mat-divider class="legalization-details-devider"></mat-divider>
</mat-card-header>
<mat-card-content>
  <div class="legalization-details-content">
    <mat-accordion [multi]="true" togglePosition="before">
      <!-- Dane Pracownika -->
      <mat-expansion-panel [expanded]="expandedPanels['employee']" (opened)="onPanelOpened('employee')" (closed)="onPanelClosed('employee')">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ 'Legalization.Details.EmployeeDetails' | translate }}</mat-panel-title>

          <a mat-button [routerLink]="['/profile', workerId]" class="header-link">{{ 'Legalization.Details.GoToWorkerProfile' | translate }}</a>
        </mat-expansion-panel-header>
        <table class="detail-table">
          <colgroup>
          <col class="detail-col-label" />
          <col class="detail-col-value" />
        </colgroup>
        <tbody>
          <tr>
            <td>{{ 'Legalization.Details.Citizenship' | translate }}</td>
            <td>{{ legalizationDetails?.Citizenship }}</td>
          </tr>
          <tr>
            <td>{{ 'Legalization.Details.IdentityDocument' | translate }}</td>
            <td>{{ legalizationDetails?.IdentityDocumentType }}</td>
          </tr>
          <tr>
            <td>{{ 'Legalization.Details.IdentityDocumentNumber' | translate }}</td>
            <td>{{ legalizationDetails?.IdentityDocumentNumber }}</td>
          </tr>
          <tr>
            <td>{{ 'Legalization.Details.Pesel' | translate }}</td>
            <td>{{ legalizationDetails?.Pesel }}</td>
          </tr>
          <tr>
            <td>{{ 'Legalization.Details.BirthDate' | translate }}</td>
            <td>{{ legalizationDetails?.DateOfBirth | date : 'dd-MM-yyyy' }}</td>
          </tr>
        </tbody>
      </table>
    </mat-expansion-panel>
    <mat-divider class="legalization-details-devider"></mat-divider>
    <!-- Dane związane z zatrudnieniem -->
    <mat-expansion-panel [expanded]="expandedPanels['employment']" (opened)="onPanelOpened('employment')" (closed)="onPanelClosed('employment')">
      <mat-expansion-panel-header togglePosition="before">
        <mat-panel-title>{{ 'Legalization.Details.EmploymentDetails' | translate }}</mat-panel-title>

        <a mat-button [routerLink]="['/profile', workerId, 'agreements']" class="header-link">{{
          'Legalization.Details.GoToWorkerAgreements' | translate
        }}</a>
      </mat-expansion-panel-header>
      <table class="detail-table">
        <colgroup>
        <col class="detail-col-label" />
        <col class="detail-col-value" />
      </colgroup>
      <tbody>
        <tr>
          <td>{{ 'Legalization.Details.Company' | translate }}</td>
          <td>{{ legalizationDetails?.AgreementDetails?.CompanyName }}</td>
        </tr>
        <tr>
          <td>{{ 'Legalization.Details.Employer' | translate }}</td>
          <td>{{ legalizationDetails?.AgreementDetails?.EmployerName }}</td>
        </tr>
        <tr>
          <td>{{ 'Legalization.Details.EmploymentType' | translate }}</td>
          <td>{{ legalizationDetails?.AgreementDetails?.EmploymentTypeName }}</td>
        </tr>
        <tr>
          <td>{{ 'Legalization.Details.AgreementType' | translate }}</td>
          <td>{{ legalizationDetails?.AgreementDetails?.AgreementTypeName }}</td>
        </tr>
        <tr>
          <td>{{ 'Legalization.Details.EmploymentDateFrom' | translate }}</td>
          <td>{{ legalizationDetails?.AgreementDetails?.EmploymentDateFrom | date : 'dd-MM-yyyy' }}</td>
        </tr>
        <tr>
          <td>{{ 'Legalization.Details.EmploymentDateTo' | translate }}</td>
          <td>{{ legalizationDetails?.AgreementDetails?.EmploymentDateTo | date : 'dd-MM-yyyy' }}</td>
        </tr>
        <tr>
          <td>{{ 'Legalization.Details.JobTitle' | translate }}</td>
          <td>{{ legalizationDetails?.AgreementDetails?.JobTitle }}</td>
        </tr>
        <tr>
          <td>{{ 'Legalization.Details.ZUSCode' | translate }}</td>
          <td>{{ legalizationDetails?.AgreementDetails?.ZusCode }}</td>
        </tr>
        <tr>
          <td>{{ 'Legalization.Details.Wages' | translate }}</td>
          <td>
            @for (wage of legalizationDetails?.AgreementDetails?.Wages; track wage) {
              <div>
                {{ wage.WageTypeName }}: {{ wage.Value }} {{ wage.Currency }}
              </div>
            }
          </td>
        </tr>
        @if (!isEmploymentAgreement()) {
          <tr>
            <td>{{ 'Legalization.Details.MonthlyHours' | translate }}</td>
            <td>{{ legalizationDetails?.AgreementDetails?.MonthlyHours }}</td>
          </tr>
        }
        @if (isEmploymentAgreement()) {
          <tr>
            <td>{{ 'Legalization.Details.WorkingTimeGroupName' | translate }}</td>
            <td>{{ legalizationDetails?.AgreementDetails?.WorkingTimeGroupName }}</td>
          </tr>
        }
      </tbody>
    </table>
    @if (legalizationDetails?.OtherAgreements && legalizationDetails?.OtherAgreements.length > 0) {
      <table class="detail-table">
        <colgroup>
        <col class="detail-col-label" />
        <col class="detail-col-value" />
      </colgroup>
      <thead>
        <tr>
          <th>{{ 'Legalization.Details.OtherAgreements' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (agreement of legalizationDetails?.OtherAgreements; track agreement; let last = $last) {
          <tr>
            <td>{{ agreement.JobTitleName }}</td>
            <td>{{ agreement.EmploymentDateFrom | date : 'dd-MM-yyyy' }} - {{ agreement.EmploymentDateTo | date : 'dd-MM-yyyy' }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</mat-expansion-panel>
<mat-divider class="legalization-details-devider"></mat-divider>
<!-- Dane dokumentu -->
<mat-expansion-panel [expanded]="expandedPanels['document']" (opened)="onPanelOpened('document')" (closed)="onPanelClosed('document')">
  <mat-expansion-panel-header togglePosition="before">
    <mat-panel-title>{{ 'Legalization.Details.DocumentDetails' | translate }}</mat-panel-title>

    <a mat-button [routerLink]="['/profile', workerId, 'documents']" class="header-link">{{
      'Legalization.Details.GoToWorkerDocuments' | translate
    }}</a>
  </mat-expansion-panel-header>
  <table class="detail-table">
    <colgroup>
    <col class="detail-col-label" />
    <col class="detail-col-value" />
  </colgroup>
  <tbody>
    <tr>
      <td>{{ 'Legalization.Details.Document' | translate }}</td>
      <td>{{ legalizationDetails?.DocumentDetails?.LegalizationDocumentTypeName }}</td>
    </tr>
    <tr>
      <td>{{ 'Legalization.Details.DocumentCategoryName' | translate }}</td>
      <td>{{ legalizationDetails?.DocumentDetails?.LegalizationDocumentCategoryName }}</td>
    </tr>
    <tr>
      <td>{{ 'Legalization.Details.DocumentNumber' | translate }}</td>
      <td>{{ legalizationDetails?.DocumentDetails?.DocumentNumber }}</td>
    </tr>
    <tr>
      <td>{{ 'Legalization.Details.DocumentSubmissionDate' | translate }}</td>
      <td>{{ legalizationDetails?.DocumentDetails?.DocumentSubmissionDate | date : 'dd.MM.yyyy' }}</td>
    </tr>
    <tr>
      <td>{{ 'Legalization.Details.DocumentStartDate' | translate }}</td>
      <td>{{ legalizationDetails?.DocumentDetails?.StartDate | date : 'dd.MM.yyyy' }}</td>
    </tr>
    <tr>
      <td>{{ 'Legalization.Details.DocumentEndDate' | translate }}</td>
      <td>{{ legalizationDetails?.DocumentDetails?.EndDate | date : 'dd.MM.yyyy' }}</td>
    </tr>
    <tr>
      <td>{{ 'Legalization.Details.DocumentStatus' | translate }}</td>
      <td>{{ legalizationDetails?.DocumentDetails?.LegalizationDocumentStatus }}</td>
    </tr>
    <tr>
      <td>{{ 'Legalization.Details.Attachments' | translate }}</td>
      <td>
        @if (legalizationDetails?.DocumentDetails?.Files?.length) {
          @for (file of legalizationDetails.DocumentDetails.Files; track file; let last = $last) {
            <a href="javascript:void(0)" (click)="download(file.Id, file.Name)" download>{{ file.Name }}</a
              >@if (!last) {
              <span>, </span>
            }
          }
        } @else {
          –
        }
      </td>
    </tr>
  </tbody>
</table>
</mat-expansion-panel>
<mat-divider class="legalization-details-devider"></mat-divider>
<!-- Pozostałe dokumenty -->
<mat-expansion-panel
  [expanded]="expandedPanels['otherDocuments']"
  (opened)="onPanelOpened('otherDocuments')"
  (closed)="onPanelClosed('otherDocuments')"
  >
  <mat-expansion-panel-header togglePosition="before">
    <mat-panel-title>{{ 'Legalization.Details.OtherDocuments' | translate }}</mat-panel-title>

    <a mat-button [routerLink]="['/profile', workerId, 'documents']" class="header-link">{{
      'Legalization.Details.GoToWorkerDocuments' | translate
    }}</a>
  </mat-expansion-panel-header>
  <table class="detail-table">
    <colgroup>
    <col class="detail-col-label" />
    <col class="detail-col-value" />
  </colgroup>
  <tbody>
    @for (document of legalizationDetails?.OtherDocuments; track document) {
      <tr>
        <td>{{ document.DocumentTypeName }}</td>
        <td>{{ document.ValidTo | date : 'dd.MM.yyyy' }}</td>
      </tr>
    }
  </tbody>
</table>
</mat-expansion-panel>
</mat-accordion>
</div>
<ngx-spinner [fullScreen]="false" id="pacman" type="pacman" [name]="spinnerName"></ngx-spinner>
</mat-card-content>
</mat-card>
